import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from '@material-ui/core';
import {
  ComposableServiceConfig,
  ComposableServiceConfigPaymentMode,
} from '../../../graphql/models';
import { I18NTextField } from '../i18n_text_field';
import { useEffect, useState } from 'react';

export type ServiceCompositionOptsEditorProps = {
  value: ComposableServiceConfig;
  onChange: (v: ComposableServiceConfig) => void;
};
export function ServiceCompositionOptsEditor(
  props: ServiceCompositionOptsEditorProps
) {
  const { value, onChange } = props;

  const {
    askAmenityPlace,
    askProducts,
    askServices,
    askVehicleInfo,
    askAvailabilitySlots,
    displayAttachments,
    displayListItemsInHomepage,
    displayPhoneNumberCta,
    displayServiceDescription,
    paymentMode,
    i18n = {},
    paymentReloadInPercentage,
  } = value;

  const [payMode, setPayMode] = useState(paymentMode);

  const triggerFieldUpdate =
    (fieldName: keyof ComposableServiceConfig) => (fieldValue: any) => {
      onChange({
        ...value,
        [fieldName]: fieldValue,
      });
    };

  useEffect(() => {
    triggerFieldUpdate('paymentMode')(payMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payMode]);

  return (
    <Grid container style={{ width: '100%' }} spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Configurazione servizio</FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={displayAttachments}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('displayAttachments')(checked)
                  }
                  name="displayAttachments"
                />
              }
              label="Mostra gli allegati"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={askAvailabilitySlots}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('askAvailabilitySlots')(checked)
                  }
                  name="askAvailabilitySlots"
                />
              }
              label="Richiedi slots per gestione disponibilità"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={displayListItemsInHomepage}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('displayListItemsInHomepage')(checked)
                  }
                  name="displayListItemsInHomepage"
                />
              }
              label="Mostra il listino in homepage"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={displayPhoneNumberCta}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('displayPhoneNumberCta')(checked)
                  }
                  name="displayPhoneNumberCta"
                />
              }
              label="Mostra CTA per telefonare all'esercente nell'homepage del servizio."
            />
            <FormControlLabel
              control={
                <Switch
                  checked={displayServiceDescription}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('displayServiceDescription')(checked)
                  }
                  name="displayServiceDescription"
                />
              }
              label="Mostra la descrizione del servizio nell'homepage del servizio."
            />
            <FormControlLabel
              control={
                <Switch
                  checked={askServices}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('askServices')(checked)
                  }
                  name="askServices"
                />
              }
              label="Richiedi la selezione di almeno un servizio."
            />
            <FormControlLabel
              control={
                <Switch
                  checked={askProducts}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('askProducts')(checked)
                  }
                  name="askProducts"
                />
              }
              label="Richiedi dopo la selezione di un servizio la selezione di uno o più prodotti."
            />
            <FormControlLabel
              control={
                <Switch
                  checked={askAmenityPlace}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('askAmenityPlace')(checked)
                  }
                  name="askAmenityPlace"
                />
              }
              label="Richiedi il luogo di svolgimento del servizio in una o più amenities del palazzo"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={askVehicleInfo}
                  onChange={(_, checked) =>
                    triggerFieldUpdate('askVehicleInfo')(checked)
                  }
                  name="askVehicleInfo"
                />
              }
              label="Richiedi le informazioni di un veicolo del garage"
            />
            <FormControl>
              <InputLabel>Modalità di pagamento</InputLabel>
              <Select value={payMode} onChange={(evt) => {
                setPayMode(evt.target.value as ComposableServiceConfigPaymentMode)
              }}>
                <MenuItem
                  value={ComposableServiceConfigPaymentMode.PAY_IMMEDIATELY}
                >
                  Pagamento immediato
                </MenuItem>
                <MenuItem
                  value={ComposableServiceConfigPaymentMode.PRE_AUTHORIZE}
                >
                  Preautorizzazione
                </MenuItem>
                <MenuItem value={ComposableServiceConfigPaymentMode.PAY_AFTER}>
                  Paga dopo la conferma della prenotazione
                </MenuItem>
                <MenuItem
                  value={ComposableServiceConfigPaymentMode.QUOTATION_ONLY}
                >
                  Nessun pagamento: le nuove prenotazioni risulteranno come
                  preventivi
                </MenuItem>
              </Select>
            </FormControl>
            {paymentMode ===
              ComposableServiceConfigPaymentMode.PRE_AUTHORIZE && (
              <>
                <FormControl>
                  <TextField
                    variant="outlined"
                    type="number"
                    label="Percentuale di incremento del totale preautorizzato"
                    style={{ width: '100%' }}
                    defaultValue={paymentReloadInPercentage}
                    onChange={(evt) =>
                      triggerFieldUpdate('paymentReloadInPercentage')(Number(evt.target.value))
                    }
                  />
                </FormControl>
                <FormControl>
                  <I18NTextField
                    value={i18n ?? {}}
                    label="Motivazione incremento del totale preautorizzato"
                    i18nFieldName="paymentReloadInPercentageReason"
                    onChange={(newValue) =>
                      triggerFieldUpdate('i18n')(newValue)
                    }
                  />
                </FormControl>
              </>
            )}
          </FormGroup>
          <FormHelperText>
            Queste informazioni possono essere modificate in qualsiasi momento
            ed andranno a modificare il comportamento del servizio
            nell&apos;applicazione.
          </FormHelperText>
        </FormControl>
      </Grid>
    </Grid>
  );
}
